class EuroAboutFaq extends HTMLElement {
  connectedCallback() {
    this.items = Array.from(this.querySelectorAll('details.euro-about-faq__item'));
    this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    this.items.forEach((details) => this.bindItem(details));
  }

  bindItem(details) {
    const summary = details.querySelector('summary');
    const panel = details.querySelector('[data-about-faq-panel]');
    if (!summary || !panel) return;

    details._faqBusy = false;
    this.syncPanel(details, panel);

    summary.addEventListener('click', (event) => {
      event.preventDefault();
      if (details._faqBusy) return;

      if (details.classList.contains('is-expanded')) {
        this.closeItem(details, panel);
      } else {
        this.openItem(details, panel);
      }
    });
  }

  syncPanel(details, panel) {
    panel.style.overflow = 'hidden';

    if (details.open) {
      details.classList.add('is-expanded');
      panel.style.height = 'auto';
      panel.style.opacity = '1';
      return;
    }

    details.classList.remove('is-expanded');
    panel.style.height = '0px';
    panel.style.opacity = '0';
  }

  openItem(details, panel) {
    if (this.reduceMotion.matches) {
      details.open = true;
      details.classList.add('is-expanded');
      panel.style.height = 'auto';
      panel.style.opacity = '1';
      return;
    }

    details._faqBusy = true;
    details.open = true;
    details.classList.add('is-expanded');
    panel.style.height = '0px';
    panel.style.opacity = '0';

    // Force reflow so the browser registers 0 before animating open.
    panel.getBoundingClientRect();

    panel.style.height = `${panel.scrollHeight}px`;
    panel.style.opacity = '1';

    const onEnd = (event) => {
      if (event.target !== panel || event.propertyName !== 'height') return;
      panel.style.height = 'auto';
      details._faqBusy = false;
      panel.removeEventListener('transitionend', onEnd);
    };

    panel.addEventListener('transitionend', onEnd);
  }

  closeItem(details, panel) {
    if (this.reduceMotion.matches) {
      details.classList.remove('is-expanded');
      details.open = false;
      panel.style.height = '0px';
      panel.style.opacity = '0';
      return;
    }

    details._faqBusy = true;
    details.classList.remove('is-expanded');

    // Lock pixel height first, then animate to 0 on the next frame.
    panel.style.height = `${panel.scrollHeight}px`;
    panel.style.opacity = '1';
    panel.getBoundingClientRect();

    panel.style.height = '0px';
    panel.style.opacity = '0';

    const onEnd = (event) => {
      if (event.target !== panel || event.propertyName !== 'height') return;
      details.open = false;
      details._faqBusy = false;
      panel.removeEventListener('transitionend', onEnd);
    };

    panel.addEventListener('transitionend', onEnd);
  }
}

if (!customElements.get('euro-about-faq')) {
  customElements.define('euro-about-faq', EuroAboutFaq);
}
